import React from "react";

const LocalTag = ({ litTerm }) => (
  <a className="local-tag" href={litTerm.showPath} role="button">
    <div className="pill">
      <span className="subtitle-2 center-aligned">
        {litTerm.name}
        {litTerm.keyExamplesCount > 1 ? ` (${litTerm.keyExamplesCount})` : ""}
      </span>
    </div>
  </a>
);

export default LocalTag;
